import accountList  from "@/helpers/AccountList";

export const PROJECT_TYPE = {
  DIGITAL: "digital",
  ANALOG: "analog",
};

const PROJECT_TYPE_LABEL = {
  [PROJECT_TYPE.DIGITAL]: "Digital",
  [PROJECT_TYPE.ANALOG]: "Analog",
};

// Account/project list the logged in user is validated against, resolved for the
// current environment in @/helpers/AccountList. See frontend/README for the
// entry shape.
let configPromise = null;

function normalizeKeys(entry) {
  return Object.keys(entry || {}).reduce((acc, key) => {
    const normalizedKey = key
      .trim()
      .replace(/([a-z0-9])([A-Z])/g, "$1_$2") // camelCase to snake_case
      .toLowerCase()
      .replace(/[\s-]+/g, "_"); // spaced keys to snake_case
    acc[normalizedKey] = entry[key];
    return acc;
  }, {});
}

function normalizeEntry(rawEntry) {
  const entry = normalizeKeys(rawEntry);
  const account_id = String(entry.account_id ?? "").trim();
  const project_id = String(entry.project_id ?? "").trim();
  const mask_profile_id = String(entry.mask_profile_id ?? "").trim();
  const type = String(entry.type ?? "").trim().toLowerCase();

  if (!account_id || !project_id) {
    return null;
  }
  if (!Object.values(PROJECT_TYPE).includes(type)) return null;

  return {
    // Unique id of the entry.
    key: `${type}:${account_id}:${project_id}`,
    account_id,
    project_id,
    mask_profile_id,
    type,
    label: String(entry.label ?? entry.name ?? "").trim(),
  };
}

// Defaults the switcher label from the project type.
function applyLabels(entries) {
  const typeCount = entries.reduce((acc, entry) => {
    acc[entry.type] = (acc[entry.type] || 0) + 1;
    return acc;
  }, {});

  return entries.map((entry) => {
    if (entry.label) return entry;
    const typeLabel = PROJECT_TYPE_LABEL[entry.type];
    return {
      ...entry,
      label:
        typeCount[entry.type] > 1
          ? `${typeLabel} (${entry.project_id.slice(0, 8)})`
          : typeLabel,
    };
  });
}

function normalizeList(rawList) {
  const seen = new Set();
  const entries = (Array.isArray(rawList) ? rawList : [])
    .map(normalizeEntry)
    .filter((entry) => {
      if (!entry) return false;
      if (seen.has(entry.key)) return false;
      seen.add(entry.key);
      return true;
    });

  return applyLabels(entries);
}

// Resolves and caches the configured list.
export function loadAccountConfig() {
  if (configPromise) return configPromise;

  configPromise = (async () => {
    const list = accountList || [];
    const entries = normalizeList(list);
    return entries;
  })();

  return configPromise;
}
